import React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    transition: 'all 0.3s ease',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    '&:hover': {
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    },
  },
  content: {
    padding: theme.spacing(2.5),
    paddingBottom: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '0.875rem',
    color: '#64748b',
    fontWeight: 700,
    lineHeight: 1.4,
  },
  iconContainer: {
    height: 40,
    width: 40,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  icon: {
    fontSize: 20,
    color: '#fff',
  },
  iconLight: {
    fontSize: 20,
    color: '#f9c31f',
  },
  valueContainer: {
    marginBottom: theme.spacing(1),
  },
  value: {
    fontSize: '1.875rem',
    fontWeight: 700,
    lineHeight: 1.2,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginTop: 0,
    lineHeight: 1.4,
  },
  trend: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),
  },
  trendText: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: '#10b981',
  },
}));

export function DashboardMetricCard({ 
  icon: Icon, 
  title, 
  value, 
  subtitle = 'All Platforms', 
  trend,
  iconColor = '#f9a620' 
}) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Box className={classes.header}>
          <Typography className={classes.title}>{title}</Typography>
          {Icon && (
            <Box 
              className={classes.iconContainer}
              style={{ backgroundColor: '#fff9eb' }}
            >
              <Icon className={iconColor === '#fef3c7' ? classes.iconLight : classes.icon} />
            </Box>
          )}
        </Box>
        <Box className={classes.valueContainer}>
          <Typography className={classes.value}>{value}</Typography>
          <Typography className={classes.subtitle}>{subtitle}</Typography>
        </Box>
        {/* {trendValue !== undefined && trendValue !== null && (
          <Box className={classes.trend}>
            <TrendingUp style={{ fontSize: 14, color: '#10b981' }} />
            <Typography className={classes.trendText}>
              {typeof trendValue === 'string' 
                ? trendValue 
                : `${isPositive ? '+' : ''}${trendValue}%`}
            </Typography>
          </Box>
        )} */}
      </CardContent>
    </Card>
  );
}

